import { ORIGINAL_VIDEO_LANGUAGE_OPTIONS } from '@src/config/languages';
import React, { useState } from 'react';
import styled from 'styled-components';

import RotatingSquare from '../../svgs/RotatingSquare';
import ItemDropdownSelect from '../common/ItemDropdownSelect';
import Modal from '../Modal';

import type { FormEvent } from 'react';

type Props = {
  onClose: () => void;
  title: string;
  subTitle?: string;
  placeholder?: string;
  cta?: string;
  selectedLanguage?: string | null;
  handleGenerate: (
    value: string,
    options: { selectedLanguage?: string | null },
  ) => void;
};
const BrandVoiceRevisionModal = (props: Props) => {
  const {
    selectedLanguage,
    placeholder = 'Describe your voice',
    subTitle = 'Make a revision',
    cta = 'Tell us what you want to be different',
  } = props;
  console.log('BrandVoiceRevisionModal, selectedLanguage', selectedLanguage);
  const [value, setValue] = useState('');
  const [language, setLanguage] = useState(selectedLanguage);
  console.log('BrandVoiceRevisionModal, language', language);
  const handleAdjustInputHeight = (e: FormEvent<HTMLTextAreaElement>) => {
    const textarea = e.target as HTMLTextAreaElement;
    textarea.style.height = textarea.scrollHeight + 'px';
  };
  return (
    <Modal isOpen={true} onClose={props.onClose}>
      <Title>{props.title}</Title>
      <SubTitle>{subTitle}</SubTitle>

      <Content>
        <span>{cta}</span>
        <Section>
          <Description
            onChange={e => setValue(e.target.value)}
            value={value}
            placeholder={placeholder}
            onInput={e => handleAdjustInputHeight(e)}
          />
        </Section>

        {selectedLanguage && (
          <Section>
            <div className="section_heading">Select Language</div>
            <ItemDropdownSelect
              action={(_, value) => value && setLanguage(value)}
              propertyName="contentLanguage"
              defaultValue={selectedLanguage}
              values={ORIGINAL_VIDEO_LANGUAGE_OPTIONS}
            />
          </Section>
        )}
      </Content>
      <Action>
        <Button
          onClick={() =>
            props.handleGenerate(value, { selectedLanguage: language })
          }
        >
          <RotatingSquare />
          Regenerate
        </Button>
      </Action>
    </Modal>
  );
};

export default BrandVoiceRevisionModal;

const Title = styled.h3`
  color: var(--text-muted);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-medium);
  text-align: center;
  margin: 0;
`;
const SubTitle = styled.h4`
  color: var(--foreground);
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  margin-top: 0;
  margin-bottom: 30px;
`;

const Content = styled.div`
  text-align: left;
  span {
    color: var(--text-secondary);
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 10px;
  }
  display: flex;
  flex-direction: column;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border);

  &:last-of-type {
    border-bottom: none;
    margin-top: 8px;
  }

  .section_heading {
    color: var(--text-secondary);
    font-size: 12px;
    font-weight: 700;
    line-height: 140%;
  }
`;

const Description = styled.textarea`
  box-sizing: border-box;
  display: flex;
  padding: 15px 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--border);
  text-align: left;
  font-size: 12px;
  line-height: 1.5;
  background-color: transparent;
  color: var(--text-secondary);
  width: 100%;
  resize: none;
  height: 50px;
`;

const Button = styled.button`
  display: flex;
  padding: 11px 16px 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 10px;
  color: var(--background);
  background-color: var(--primary);
  width: fit-content;
  cursor: pointer;
  font-weight: 700;
  font-size: 14px;
  outline: 0;
  border: 0;
`;

const Action = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-bottom: 10px;
`;
